import { categorizationOntology } from "../categorizationOntology";
import { widgetConfig } from "../../config/widgetConfig";
import { feedFactoryAxios } from "../apiClient";

export type GenericCategorizationOntology = {
  categorizations: ({
    categorizationId: string;
    categorization: string;
    cnetID: string;
    entityType: string;
    child: ({
      categorizationId: string;
      categorization: string;
      cnetID: string;
      deprecated?: undefined;
    } | {
      categorizationId: string;
      categorization: string;
      cnetID: string;
      deprecated: boolean;
    })[];
    deprecated?: undefined;
  } | {
    categorizationId: string;
    categorization: string;
    cnetID: string;
    entityType: string;
    deprecated: boolean;
    child: {
      categorizationId: string;
      categorization: string;
      cnetID: string;
    }[];
  } | {
    categorizationId: string;
    categorization: string;
    cnetID: string;
    entityType: string;
    deprecated: boolean;
    child?: undefined;
  } | {
    categorizationId: string;
    categorization: string;
    cnetID: string;
    entityType: string;
    deprecated: boolean;
    child: {
      categorizationId: string;
      categorization: string;
      deprecated: boolean;
      cnetID: string;
    }[];
  } | {
    categorizationId: string;
    categorization: string;
    cnetID: string;
    deprecated: boolean;
    child: {
      categorizationId: string;
      categorization: string;
      cnetID: string;
    }[];
    entityType?: undefined;
  })[];
};

export type CustomCategorizationOntology = {
  categorizationId: string;
  categorization: string;
  cnetID: string;
  entityType: string;
  child: ({
    categorizationId: string;
    categorization: string;
    cnetID: string;
    deprecated?: undefined;
  } | {
    categorizationId: string;
    categorization: string;
    cnetID: string;
    deprecated: boolean;
  })[];
  deprecated?: undefined;
}[];

/**
 * The account's own ontology has moved around over time: it is served as a
 * `categorizationOntology` object on the account, was a JSON string before that,
 * and older accounts kept it under `metaData`. Accept all three, and hand back
 * the bare `categorizations` array the callers filter on.
 */
const readAccountOntology = (account: any): CustomCategorizationOntology | null => {
  const candidates = [account?.categorizationOntology, account?.metaData?.categorizationOntology];

  for (const candidate of candidates) {
    if (!candidate) {
      continue;
    }

    let parsed = candidate;
    if (typeof candidate === "string") {
      try {
        parsed = JSON.parse(candidate);
      } catch {
        continue;
      }
    }

    const categorizations = Array.isArray(parsed) ? parsed : parsed?.categorizations;
    if (Array.isArray(categorizations) && categorizations.length > 0) {
      return categorizations as CustomCategorizationOntology;
    }
  }

  return null;
};

export const selectedCategorizationOntology: () => Promise<any> = async () => {
  if (!widgetConfig.baseParams.location.userorganization) {
    return categorizationOntology;
  }

  try {
    const organisation = await feedFactoryAxios.get("accounts", {
      params: {
        search: widgetConfig.baseParams.location.userorganization,
      },
    });

    // This runs during module initialisation, so anything thrown here takes the
    // whole widget down with it. Falling back to the bundled ontology keeps it
    // rendering.
    return readAccountOntology(organisation.data?.results?.[0]) ?? categorizationOntology;
  } catch (error) {
    console.error("Could not load the account categorization ontology", error);
    return categorizationOntology;
  }
};